var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckmark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 8,
    viewBox: "0 0 12 8",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m10.7653 2.39088c.338-.33796.338-.88589 0-1.22384-.3379-.337954-.88587-.337954-1.22382 0l-4.58032 4.58031-2.50339-2.50339c-.33795-.33795-.88588-.33795-1.22384 0-.33795.33796-.33795.88589 0 1.22384l3.10567 3.10566c.00316.00326.00635.0065.00957.00972.16701.16702.38531.2515.60421.25344.22408.00202.4488-.08246.61978-.25343.00325-.00326.00648-.00653.00967-.00983z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckmark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/checkmark.d8ff3a85059dd0ec51a3afcb6a0ccd58.svg";